import icons from 'url:../../img/icons.svg';
import previewView from './previewView.js';
import view from './view.js';

class bookmarksView extends view {
  _parentEl = document.querySelector('.bookmarks__list');
  _errorMessage = `No bookmarks yet ! Find a nice recipe and bookmark it :)`;
  _message = '';

  addHandlerRender(subscriber) {
    window.addEventListener(`load`, subscriber);
  }

  _generateMarkup() {
    return this._data
      .map(bookmark => previewView.render(bookmark, false))
      .join('');
  }
}

export default new bookmarksView();
